module.exports = __webpack_public_path__ + "static/media/video-11.b4b12543.mp4";